module.exports = __webpack_public_path__ + "static/media/np_weight.def941ec.svg";